document.addEventListener("DOMContentLoaded", init);

function init() {
    // Profile picture upload link
    let input = <HTMLInputElement>document.querySelector("#ProfilePicture");
    let uploadBtn = document.querySelector("#ProfilePictureUpload");

    input.addEventListener("change", function () {
        if (input.value) {
            uploadBtn.innerHTML = input.value.split("\\").pop();
        }
        else {
            uploadBtn.innerHTML = "Upload";
        }
    })

    // Password field requirments message
    let passwordRequirements = document.querySelector(".register-form-password-requirements-js");

    if (document.querySelector(".register-form-password").querySelector(".field-validation-error")) {
        passwordRequirements.classList.add("register-form-password-requirements-hidden");
    }
    else if (passwordRequirements.classList.contains(".register-form-password-requirements-hidden")) {
        passwordRequirements.classList.remove("register-form-password-requirements-hidden");
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/pages/register-page.ts